import React, { Component } from 'react';
import moment from 'moment';
import InfoBox from './InfoBox.js';
import Calendar from '../../../svg/Calendar.js';
import Formsy from 'formsy-react';
import FormsySelectMui from '../../form/FormsySelectMui';

const weekdays = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
};

class StartDate extends Component {
  state = {
    dayOfWeek: '',
    monthBasedOptions: [
      {
        month: {
          label: '',
          value: ''
        },
        days: [
          {
            label: '',
            value: ''
          }
        ]
      }
    ],
    month: '',
    day: '',
    selectedDate: '',
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { monthBasedOptions, month, day, isCurrentStep } = this.state;

    const months = monthBasedOptions.map(el => el.month);

    // get index of current month in accumulator array
    let currentMonthIx = 0; //need

    currentMonthIx =
      months.findIndex(el => el.label === month) > -1
        ? months.findIndex(el => el.label === month)
        : 0;

    let days = [];
    days = monthBasedOptions[currentMonthIx].days;

    return (
      <React.Fragment>
        <InfoBox
          headline="Great. Lets pick a start date!"
          subline="You can skip a week or make other changes later."
          icon={<Calendar />}
        />

        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="month"
                placeholder="Month"
                value={month}
                options={months}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="day"
                placeholder="Day"
                value={day}
                options={days}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    if (name === 'month') {
      // clear day if month changed
      this.setState({ [name]: value, day: '' });
    } else {
      this.setState({ [name]: value });
    }
  };

  generateOptions = () => {
    const { client } = this.props;
    const { service_start_date = '' } = client;
    const { dayOfWeek } = this.state;
    const sevenDaysFromNow = moment().add(7, 'd');

    let startDate;
    // loop through 7 days to find the first valid start date
    for (let i = 0; i < 7; i++) {
      const date = moment(sevenDaysFromNow).add(i, 'd');
      if (date.day() === dayOfWeek) {
        startDate = date;
      }
    }

    let options = [];

    // get dates for next 12 weeks
    for (let i = 0; i < 12; i++) {
      const date = moment(startDate).add(7 * i, 'd');
      options.push(date);
    }

    const monthBasedOptions = options.reduce((acc, cur, ix) => {
      // Format e.g. January 2020
      const formattedMonth = cur.format('MMMM YYYY');
      // Format e.g. Monday the 27th
      const formattedDay = `${cur.format('dddd')} the ${cur.format('Do')}`;

      // if month not yet in array add it with label and value
      if (!acc.find(el => el.month.label === formattedMonth)) {
        acc.push({
          month: { label: formattedMonth, value: formattedMonth },
          days: []
        });
      }

      // get index of current month in accumulator array
      const currentMonthIx = acc.findIndex(
        el => el.month.label === formattedMonth
      );
      // add moment date objed to that month
      acc[currentMonthIx].days.push({
        dateTime: cur,
        label: formattedDay,
        value: cur.format('MMMM D YYYY') // Format e.g. January 27 2020
      });

      return acc;
    }, []);

    // set starting values - if none already selected set first available option
    const month = service_start_date
      ? moment(service_start_date).format('MMMM YYYY') // Format e.g. January 2020
      : monthBasedOptions[0].month.value;
    const day = service_start_date
      ? moment(service_start_date).format('MMMM D YYYY') // Format e.g. January 27 2020
      : monthBasedOptions[0].days[0].value;

    this.setState({
      monthBasedOptions,
      month,
      day
    });
  };

  handleClientUpdate = () => {
    const { day } = this.state;

    const updatedClient = {
      service_start_date: moment(day).toISOString()
    };

    // Callback loads up the menu for the following select menu screen
    this.props.updateClient(updatedClient, this.props.lookupMenu);
  };

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (
      prevProps.client.client_service_preferences !==
      client.client_service_preferences
    ) {
      const { client_service_preferences } = client;
      // Get day of week from previous screen
      let dayOfWeek =
        client_service_preferences.length > 0
          ? client_service_preferences[0].day_of_week
          : '';

      this.setState(
        {
          dayOfWeek: weekdays[dayOfWeek]
        },
        this.generateOptions
      );
    }

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }

  componentDidMount() {
    const { client } = this.props;

    const { client_service_preferences } = client;
    // Get day of week from previous screen
    let dayOfWeek =
      client_service_preferences.length > 0
        ? client_service_preferences[0].day_of_week
        : '';

    this.setState(
      {
        dayOfWeek: weekdays[dayOfWeek]
      },
      this.generateOptions
    );
  }
}

export default StartDate;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/StartDate.js